var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoWithdrawalPerformed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_withdrawal_performed",
    d: "M509.807,985.119a6,6,0,0,1,3.228-10.1H494.88a.228.228,0,0,0-.226.23v7.86a2.554,2.554,0,0,0,2.533,2.575h13.266A6.093,6.093,0,0,1,509.807,985.119Zm-7.034-1.425a1.738,1.738,0,0,1-1.266.547v0a4.515,4.515,0,0,0-3.742-.5,1.8,1.8,0,0,1-.051-2.52,1.734,1.734,0,0,1,2.48-.052l.051.052a1.734,1.734,0,0,1,2.479-.051A1.8,1.8,0,0,1,502.773,983.694Zm15.042-8.45v1.176a5.785,5.785,0,0,0-2.936-1.4h2.71v0A.23.23,0,0,1,517.815,975.244Zm-23.16-2.748v-1.243a2.555,2.555,0,0,1,2.534-2.573h18.093a2.555,2.555,0,0,1,2.534,2.575V972.5h0a.229.229,0,0,1-.228.229H494.881A.228.228,0,0,1,494.655,972.5Zm19.3,3.628a4.779,4.779,0,1,0,4.7,4.778A4.741,4.741,0,0,0,513.956,976.124Zm3.367,3.469-3.947,4.011a.286.286,0,0,1-.195.081.26.26,0,0,1-.188-.081l-2.4-2.459a.284.284,0,0,1,0-.386l.573-.585a.276.276,0,0,1,.191-.079v0a.279.279,0,0,1,.193.077l1.637,1.676,3.177-3.229a.266.266,0,0,1,.193-.082.261.261,0,0,1,.19.082l.577.582A.282.282,0,0,1,517.323,979.593Z",
    transform: "translate(-494.654 -968.68)",
    fill: "#00a1af"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoWithdrawalPerformed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_withdrawal_performed.5475766084907f724921867ab19cacaa.svg";